module.exports = __webpack_public_path__ + "givebutter-changelog-cae90c2012c2ed3c1a05dca244b9a5ef.webp";